import React, { useState } from 'react'
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Users } from '../api/Users';
import LocaleSelector from '../components/LocaleSelector';
import { useFullScreenLoader } from '../contexts/fullScreenLoader';
import { useToasts } from '../contexts/toasts';

export default function ForgotPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");
  const { showLoader, hideLoader } = useFullScreenLoader();
  const { showToast } = useToasts();
  const [validated, setValidated] = useState<boolean>();

  const handleSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
    const form = evt.currentTarget;
    evt.stopPropagation();
    evt.preventDefault();
    setValidated(true);

    if (form.checkValidity() === true) {
      showLoader!();

      Users.resetPassword(email)
        .then(
          () => {
            hideLoader!();
            showToast!('user-success', 'An email has been sent to the address you provided', 'Success', 'success');
            navigate('/login');
          },
          (err) => {
            hideLoader!();
            const message = err.response?.data?.message || err.message;
            const status = err.response?.status;
            showToast!('user-error', message, `User Error ${status ? `(${status})` : ''}`, 'danger');
          }
        )
    }
  }

  const handleEmailChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const value = evt.target.value;
    setEmail(value);
  }

  const cancel = () => navigate('/login');

  return (
    <Container className="py-3">
      <Card className="mt-5 mb-3">
        <Form validated={validated} noValidate onSubmit={handleSubmit}>
          <Card.Body>

            <Row className="justify-content-end">
              <Col md={2}>
                <LocaleSelector />
              </Col>
            </Row>

            <div className="py-3 mb-3 text-center">
              <h5>{t('passwordForgot.title')}</h5>
              <h6 className="text-muted mb-0">{t('passwordForgot.subtitle')}</h6>
            </div>

            <Form.Group controlId="user-email">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" size="sm" placeholder={t('userEdit.placeholders.email')} value={email} onChange={handleEmailChange} required />
              <Form.Control.Feedback type="invalid">{t('errors.requiredField', { field: "Email" })}</Form.Control.Feedback>
            </Form.Group>
          </Card.Body>

          <Card.Footer className="bg-white d-flex justify-content-between">
            <Col md={2}>
              <Button size="sm" className="w-100 border" variant="light" type="button" onClick={cancel}>{t('common.cancel')}</Button>
            </Col>

            <Col md={2}>
              <Button size="sm" className="w-100" variant="success" type="submit">{t('common.confirm')}</Button>
            </Col>
          </Card.Footer>
        </Form>
      </Card>
    </Container>
  )
}